import { FileDownloadOutlined } from "@mui/icons-material";
import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CodeReport from "../../migrateAsCode/reports/codeReport";
import OverallReport from "./overallReport";
import EnhancedTable from "./serviceCodeTable";
import { useStyles } from "./styles";
import TopServicesReport from "./topServicesReport";

const AssessmentReport = ({ data, handleDownload, state, onClose }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [reportData, setReport] = useState(null);
  const [soretdData, setSortedData] = useState([]);

  useEffect(() => {
    setSortedData([...data?.services].sort((a, b) => b.total - a.total));
  }, [data]);

  const onDownload = () => {
    setLoading(true);
    handleDownload(() => setLoading(false));
  };

  const renderDetails = () => {
    const { credential, region } = state;
    const contentData = [
      { label: "Account", value: credential?.accountNumber },
      { label: "Region", value: region?.region },
    ];
    return (
      <Box className={classes.dialogContent}>
        {contentData.map((obj) => {
          return (
            <Typography>
              {obj.label} : {obj.value}
            </Typography>
          );
        })}
      </Box>
    );
  };

  return (
    <Box>
      {reportData ? (
        <CodeReport state={reportData} onClose={() => setReport(null)} />
      ) : (
        <>
          {renderDetails()}
          <Grid container spacing={3} mt={0.5} alignSelf="stretch">
            <Grid item md={6}>
              <OverallReport data={data} />
            </Grid>
            <Grid item md={6}>
              <TopServicesReport data={data} />
            </Grid>
            <Grid item md={12}>
              <EnhancedTable
                state={state}
                data={soretdData}
                onSuccess={(val) => setReport({ ...state, service: val })}
              />
            </Grid>
            <Grid item md={12}>
              <Box className={classes.footerView}>
                <Typography>
                  Click download for terraform/non terraform resource
                </Typography>
                <Button
                  onClick={onDownload}
                  startIcon={
                    loading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <FileDownloadOutlined />
                    )
                  }
                  variant="contained"
                  sx={{ minWidth: "125px" }}
                >
                  Download
                </Button>
                <Button onClick={onClose} variant="outlined">
                  Close
                </Button>
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default AssessmentReport;
